import { DropDownOptions } from '../types/common'
import strings from '../l10n'

export const countryDropDownOptions: DropDownOptions[] = [
  { label: strings.UNITED_STATES, value: 'US' },
  { label: strings.CANADA, value: 'CA' },
  { label: strings.MEXICO, value: 'MX' },
]

export const paginationLimitOptions: DropDownOptions[] = [
  { label: '20', value: '20' },
  { label: '50', value: '50' },
  { label: '100', value: '100' },
]
